import { Copy, Trash2, TrendingUp, X } from "lucide-react";
import { Button } from "@/components/ui/button";

type CalendarBulkActionBarProps = {
  selectedCount: number;
  onClear: () => void;
  onPeriodize?: () => void;
  onCopy?: () => void;
  onRemove?: () => void;
  removeLabel?: string;
};

export function CalendarBulkActionBar({
  selectedCount,
  onClear,
  onPeriodize,
  onCopy,
  onRemove,
  removeLabel = "Remove",
}: CalendarBulkActionBarProps) {
  if (selectedCount <= 0) return null;

  return (
    <div className="pointer-events-auto flex items-center gap-1 rounded-full border bg-popover/95 px-2 py-1.5 shadow-lg backdrop-blur-md animate-in fade-in slide-in-from-bottom-2">
      <span className="px-2 text-sm font-medium tabular-nums">
        {selectedCount} selected
      </span>
      {onPeriodize ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="rounded-full"
          onClick={onPeriodize}
        >
          <TrendingUp />
          Periodize
        </Button>
      ) : null}
      {onCopy ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="rounded-full"
          onClick={onCopy}
        >
          <Copy />
          Copy
        </Button>
      ) : null}
      {onRemove ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="rounded-full text-destructive hover:text-destructive"
          onClick={onRemove}
        >
          <Trash2 />
          {removeLabel}
        </Button>
      ) : null}
      <Button
        type="button"
        variant="ghost"
        size="icon-xs"
        className="rounded-full"
        onClick={onClear}
        aria-label="Clear selection"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
